import { handleActions } from 'redux-actions';

import { SetSelectedSegmentId, setSelectedSegmentId, setNextSegmentId } from './actions';

const initialState = 0;

const selectedSegmentIdReducer = handleActions(
	{
		[setSelectedSegmentId.toString()]: (_, { payload }: SetSelectedSegmentId) => payload,
		[setNextSegmentId.toString()]: state => state + 1
	},
	initialState
);

export default selectedSegmentIdReducer;
